// ============================================================================
//  COACH CONFIGURATION — the single source of truth for all brand copy.
// ============================================================================

export const coach = {
  firstName: "Ronit",
  lastName: "Ramchandani",
  fullName: "Ronit Ramchandani",
  businessName: "Ronit Coaching",
  logoTop: "RONIT",
  logoBottom: "COACHING",

  tagline: "Online fitness coaching",
  email: "ronit.ramchandani@gmail.com",

  // Local physique photography (Ronit)
  images: {
    hero: "/coach/ronit-hero.webp",           // WebsiteHeader — locker-room physique
    about: "/coach/ronit-about.webp",         // Website2 — gym back pose
    approach: "/coach/ronit-approach.webp",   // Website3 — training image
    whatYouGet: "/coach/ronit-whatyouget.webp", // Website4 — mirror physique
  },

  hero: {
    badge: "Now Accepting Clients",
    // Kinetic headline — each string is one masked line
    headline: ["BUILD THE", "PHYSIQUE", "YOU ACTUALLY", "WANT."],
    sub: "1-on-1 online coaching built around your goals, lifestyle and experience. Personalized training, realistic nutrition and the accountability you need to make consistent progress.",
    primaryCta: "Apply for Coaching",
    secondaryCta: "Learn More",
  },

  // First-person story — built on consistency, no fabricated transformation
  about: {
    kicker: "The Story",
    heading: "BUILT THROUGH CONSISTENCY.",
    paragraphs: [
      "Building a physique you're proud of doesn't come from finding the perfect workout or following an extreme diet for a few weeks. It comes from having the right plan and executing it consistently.",
      "Through years of training, I've learned that the biggest difference between staying stuck and making real progress is having structure — knowing exactly what to train, how to progress, what to eat and what to adjust when results slow down.",
      "That's the same approach I bring to coaching. No random workouts. No crash diets. No unnecessary complexity.",
      "Just a personalized plan, consistent accountability and a clear strategy designed around your goals and your lifestyle.",
    ],
    signature: "— Ronit Ramchandani",
  },

  approach: {
    kicker: "The Approach",
    heading: "TRAIN WITH PURPOSE.",
    pillars: [
      { icon: "Target", title: "Smart Training", desc: "Every exercise, set and progression should have a reason behind it. Your program evolves as you get stronger." },
      { icon: "Salad", title: "Realistic Nutrition", desc: "A nutrition strategy built around your goals and foods you actually enjoy — not an unsustainable crash diet." },
      { icon: "Repeat", title: "Consistent Accountability", desc: "Regular feedback and adjustments keep you moving forward even when motivation isn't perfect." },
    ],
  },

  whatYouGet: {
    kicker: "The System",
    heading: "WHAT YOU GET",
    sub: "Everything you need to stop guessing and start progressing — built around your goals, your schedule and your lifestyle.",
    features: [
      { icon: "Dumbbell", title: "Custom Training", desc: "A personalized program built around your goals, experience, schedule and available equipment." },
      { icon: "Utensils", title: "Personalized Nutrition", desc: "A realistic strategy that provides structure without forcing your entire life to revolve around dieting." },
      { icon: "CalendarCheck", title: "Weekly Check-Ins", desc: "Regular progress reviews allow Ronit to adjust your plan based on how your body is responding." },
      { icon: "MessageCircle", title: "Direct Coach Access", desc: "Ask questions, get feedback and receive support between check-ins instead of being left to figure everything out yourself." },
      { icon: "Video", title: "Form Feedback", desc: "Send exercise videos for technique feedback so you can train effectively and get more from every rep." },
      { icon: "TrendingUp", title: "Progressive Adjustments", desc: "Your program evolves as you progress instead of leaving you stuck repeating the same plan forever." },
    ],
  },

  marquee: ["STRENGTH", "DISCIPLINE", "MUSCLE", "CONFIDENCE", "CONSISTENCY", "PROGRESS"],

  results: {
    kicker: "Real Clients",
    heading: "REAL RESULTS.",
    sub: "Real clients. Real work. The transformations speak for themselves.",
    // Four real client transformations (Before → After). Populated once images are received.
    clients: [
      {
        before: "/coach/t1-before.jpg",
        after: "/coach/t1-after.jpg",
        beforePos: "50% 24%",
        afterPos: "50% 60%",
      },
      {
        before: "/coach/t2-before.webp",
        after: "/coach/t2-after.webp",
        beforePos: "50% 42%",
        afterPos: "42% 34%",
      },
      {
        before: "/coach/t3-before.webp",
        after: "/coach/t3-after.webp",
        beforePos: "50% 16%",
        afterPos: "50% 30%",
      },
      {
        before: "/coach/t4-before.webp",
        after: "/coach/t4-after.webp",
        beforePos: "50% 20%",
        afterPos: "50% 26%",
      },
    ],
  },

  contact: {
    kicker: "Start Here",
    heading: "READY TO CHANGE YOUR PHYSIQUE?",
    sub: "Apply for 1-on-1 coaching and tell Ronit about your goals. If you're a good fit, he'll reach out personally.",
  },

  pageTitle: "Ronit Coaching | Online Fitness Coaching",
  metaDescription:
    "Ronit Coaching offers personalized 1-on-1 online fitness coaching with custom training, realistic nutrition and consistent accountability designed to help you build muscle, lose fat and transform your physique.",
  og: {
    title: "Ronit Coaching | Online Fitness Coaching",
    description:
      "Personalized online fitness coaching designed to help you build muscle, lose fat and create sustainable results.",
  },
};

export default coach;
